import { manufacturingFetch } from "@/lib/manufacturingClient";
import type {
  MfgPricingAlertPreviewResponse,
  MfgPricingNotificationSettingsResponse,
  MfgRepresentativeFullCostMode,
} from "@/lib/manufacturing/pricingNotificationTypes";

export async function getManufacturingPricingNotificationSettings() {
  return manufacturingFetch<MfgPricingNotificationSettingsResponse>(
    "/api/mfg/pricing/notification-settings",
    { method: "GET" },
  );
}

export async function upsertManufacturingPricingNotificationSettings(body: {
  alert_threshold_pct?: number;
  representative_full_cost_mode?: MfgRepresentativeFullCostMode;
  fixed_floor_usd?: number | null;
  pinned_model_id?: string | null;
  enable_assumed_pct_rule?: boolean;
  assumed_variance_threshold_pct?: number;
  bucket_overrides?: Array<{ bucket_id: string; alert_threshold_pct: number }>;
}) {
  return manufacturingFetch<MfgPricingNotificationSettingsResponse>(
    "/api/mfg/pricing/notification-settings/upsert",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    },
  );
}

export async function previewManufacturingPricingAlert(params: {
  plant_id: string;
  bucket_id?: string;
  bucket_variance_usd: number;
  bucket_assumed_usd?: number;
}) {
  const qs = new URLSearchParams({
    plant_id: params.plant_id,
    bucket_variance_usd: String(params.bucket_variance_usd),
  });
  if (params.bucket_id) qs.set("bucket_id", params.bucket_id);
  if (typeof params.bucket_assumed_usd === "number") {
    qs.set("bucket_assumed_usd", String(params.bucket_assumed_usd));
  }
  return manufacturingFetch<MfgPricingAlertPreviewResponse>(
    `/api/mfg/pricing/alert-preview?${qs.toString()}`,
    { method: "GET" },
  );
}

export type { MfgPricingNotificationSettings } from "@/lib/manufacturing/pricingNotificationTypes";
